<div class="flex">
  <lib-itoaster />
  <board-sidebar />

  <div class="flex h-screen flex-1 flex-col overflow-auto">
    <div class="min-w-[1280px] flex-1">
      @if (isTest || isAdminLogin()) {
        <div class="sticky flex w-full items-center justify-between bg-orange-600 px-4 py-1.5 text-white">
          <div>
            @if (isTest) {
              <span class="font-semibold">Demo environment</span>
            }
            @if (isAdminLogin()) {
              <span> • Admin Board</span>
            }
          </div>
          <IButton label="Debug Info" color="white" (onClick)="printDebugInfo()" size="sm" />
        </div>
      }
      @if (globalWarning$ | async) {
        <div class="sticky top-0 z-10 w-full bg-rose-100 px-4 py-1 font-medium text-rose-600">
          {{ globalWarning$ | async }}
        </div>
      }
      <page-layout>
        <router-outlet />
      </page-layout>
    </div>
  </div>
</div>
